import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TriggerMenuService {
  menuTriggered: Subject<string> = new Subject<string>();
}

